import React from "react";
import styles from "./styles.module.scss";
import CommunityLinks from "../components/CommunityLinks";
import SocialLinks from "../components/SocialLinks";
import { SentinelLogo } from "../assets/logos";

const Footer = () => {
  return (
    <div id="footer">
      <section className={styles.footerTop}>
        <section className={styles.footerTopLeft}>
          <SentinelLogo />
          <SocialLinks />
        </section>
        <section className={styles.footerTopRight}>
          <CommunityLinks />
        </section>
      </section>
      <section className={styles.footerBottom}>
        <section>
          <span className={styles.rightsReserved}>&copy; 2017-{`${new Date().getFullYear()}`} Sentinel. All rights reserved.</span>
        </section>
      </section>
    </div>
  );
};

export default Footer;
